import { render, staticRenderFns } from "./BFlowEditor.vue?vue&type=template&id=1036ac0c&"
import script from "./BFlowEditor.vue?vue&type=script&lang=js&"
export * from "./BFlowEditor.vue?vue&type=script&lang=js&"
import style0 from "./BFlowEditor.vue?vue&type=style&index=0&id=1036ac0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports